import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@grupoboticario/flora-react';
import { user, Utilities } from 'core';
import { formatCycle } from 'core/utilities/strings/format-cycle';
import { LoaderFullScreen, ResponsiveFloraTypography, Text } from 'ui/components/primitives';
import { useChangeCycle } from 'ui/pages/hooks';

import { FeedbackMessage } from '../FeedbackMessage';
import { Button } from '../styles/ExtendedCaptation.styles';

const BuyOnlyER = () => {
  const { goToNewCycle } = useChangeCycle();

  const {
    data: { avaliableCycles, cycle },
  } = user.hooks.useUser();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onClose = (e: UIEvent) => {};

  if (avaliableCycles.status === Utilities.STATUS.RUNNING) {
    return <LoaderFullScreen message="" />;
  }

  if (
    avaliableCycles.status === Utilities.STATUS.SUCCESS ||
    avaliableCycles.status === Utilities.STATUS.ERROR
  ) {
    return <FeedbackMessage />;
  }

  return (
    <Modal open={true}>
      <ModalContent size="large" data-testid="can-buy-in-extended-cyle-in-er">
        <ModalHeader>
          <ResponsiveFloraTypography as="h1" fontSize="subtitle" css={{ margin: 0 }}>
            Fim do período de tolerância
          </ResponsiveFloraTypography>
        </ModalHeader>
        <ModalBody>
          <Text color="medium-light-1" variant="body-large-short">
            Você ainda pode realizar pedidos no Ciclo 01 no Espaço do Revendedor até o final do dia
            de hoje.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            autotagging-flora="on"
            data-flora="button"
            data-flora-text={`Ir para o Ciclo ${formatCycle(cycle.nextCycle)}`}
            data-autotagging-flora-section="fim-do-periodo-de-tolerancia"
            onClick={goToNewCycle}
          >
            Entendi
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default BuyOnlyER;
